export enum RecruiterPaymentDetailTypes {
    FETCH_RECRUITER_PAYMENT_DETAIL_SUCCESS = "FETCH_RECRUITER_PAYMENT_DETAIL_SUCCESS",
    FETCH_RECRUITER_PAYMENT_DETAIL_REQUEST = "FETCH_RECRUITER_PAYMENT_DETAIL_REQUEST",
    FETCH_RECRUITER_PAYMENT_DETAIL_FAILURE = "FETCH_RECRUITER_PAYMENT_DETAIL_FAILURE",
}